import {
  Announcement02Icon,
  InfoCircleIcon,
  InfoHexagonIcon,
  NotificationMessageIcon,
  ThumbsUpIcon,
} from '@systemeio/icons'
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum'
import type { NotificationBaseItemInterface } from '../types/base-notification-interface'

export const getNotificationIcon = (notification: NotificationBaseItemInterface) => {
  switch (notification.eventType) {
    case NotificationTypeEnum.CommentOnCommunityPost:
    case NotificationTypeEnum.CommentReplyOnComment:
    case NotificationTypeEnum.CommentOnCourseCreatedByMe:
      return <NotificationMessageIcon className="text-icon-accent size-5 shrink-0" />
    case NotificationTypeEnum.MentionInCommentOnCommunityPost:
    case NotificationTypeEnum.MentionInCommunityPost:
    case NotificationTypeEnum.CommunityNewPendingPost:
    case NotificationTypeEnum.CommunityPostIsPublished:
      return <Announcement02Icon className="text-icon-accent size-5 shrink-0" />
    case NotificationTypeEnum.CommunityPostIsLiked:
    case NotificationTypeEnum.CommentIsLiked:
      return <ThumbsUpIcon className="text-icon-accent size-5 shrink-0" />
    case NotificationTypeEnum.WithdrawalMethodOfAffiliateIsNotSet:
    case NotificationTypeEnum.ProfileInformationOfAffiliateIsNotFilled:
    case NotificationTypeEnum.DomainAuthenticationsNotValid:
    case NotificationTypeEnum.AffiliatePayoutFailed:
      return <InfoHexagonIcon className="text-icon-warning size-5 shrink-0" />
    default:
      return <InfoCircleIcon className="text-icon-warning size-5 shrink-0" />
  }
}
